<template>
  <div id="about">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="about-shell">
            <p class="eyebrow">About IMEJ Tech</p>
            <h1>Professional websites designed with clarity, purpose, and care.</h1>
            <p class="lead">
              IMEJ Tech helps individuals and businesses create polished online experiences that are
              modern, responsive, and aligned with their goals.
            </p>

            <div class="row mt-4">
              <div class="col-md-6">
                <div class="info-card">
                  <h3>What I do</h3>
                  <p>
                    I turn ideas into websites that feel professional and easy to use. Whether you need a
                    fresh site, a redesign, or support with a platform like WordPress or Squarespace, I focus
                    on thoughtful design and clear communication.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-card">
                  <h3>What makes the work stand out</h3>
                  <p>
                    Every project is built around your message, your audience, and the experience you want
                    visitors to have. I combine strong visual design with responsive development and practical
                    structure so your website works well on every screen.
                  </p>
                </div>
              </div>
            </div>

            <div class="cta-box">
              <router-link class="btn btn-primary btn-lg" to="/Contact">
                <i class="fas fa-phone-volume"></i> Let’s Talk
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped>
#about {
  min-height: 100vh;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 120s ease-in-out infinite;
}
.about-shell {
  background: rgba(7, 17, 31, 0.9);
  border-radius: 18px;
  padding: 36px;
  color: white;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.8rem;
  color: #c5d4ff;
  margin-bottom: 8px;
}
h1 {
  font-size: 2rem;
  margin-bottom: 12px;
}
.lead {
  color: #dde7ff;
  line-height: 1.8;
}
.info-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 20px;
  height: 100%;
}
.info-card h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
}
.info-card p {
  color: #e4ecff;
  line-height: 1.8;
}
.cta-box {
  margin-top: 24px;
}
.btn-primary {
  padding: 10px 18px;
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
